import { render } from "./ContractItemWrap.vue?vue&type=template&id=72689d89&scoped=true"
import script from "./ContractItemWrap.vue?vue&type=script&lang=js"
export * from "./ContractItemWrap.vue?vue&type=script&lang=js"

import "./ContractItemWrap.vue?vue&type=style&index=0&id=72689d89&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72689d89"]])

export default __exports__